export default (content) => {
  try {
    const byteCharacters = atob(content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const newWindow = window.open('', '_blank');

    if (newWindow) {
      newWindow.onload = function () {
        URL.revokeObjectURL(pdfUrl);
      };

      const iframe = newWindow.document.createElement('iframe');
      iframe.style.border = 'none';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.src = pdfUrl;

      const body = newWindow.document.body;
      body.style.margin = '0';
      body.style.overflow = 'hidden';
      body.appendChild(iframe);
    }
  } catch (error) {
    console.error('Error displaying PDF:', error);
  }
}
